import { ServicesInterface, useOpenDashApp } from "..";

export function useOpenDashServices(): ServicesInterface {
  const app = useOpenDashApp();

  return app.services;
}
